import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'panel.support.'

@vsingleton()
export class PanelTicketRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'tickets.'

  index() {
    return this.ziggyRoute('index')
  }

  store() {
    return this.ziggyRoute('store')
  }

  show(ticketId: number) {
    return this.ziggyRoute('show', ticketId)
  }

  newAnswer(ticketId: number) {
    return this.ziggyRoute('new_answer', ticketId)
  }

  openTicket(ticketId: number) {
    return this.ziggyRoute('open_ticket', ticketId)
  }

  closeTicket(ticketId: number) {
    return this.ziggyRoute('close_ticket', ticketId)
  }
}
